<div class="signing-logs-container">
    <div class="header-section mb-3">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">
                <i class="fa-solid fa-file-signature me-2"></i>
                Signing Logs
            </h3>
            <div class="header-actions">
                <button class="btn btn-outline-primary me-2" (click)="toggleCard()">
                    <i class="fa-solid fa-filter me-1"></i>
                    Filtre
                </button>
                <button class="btn btn-success" (click)="exportCsv()" [disabled]="isExporting">
                    <mat-spinner diameter="18" *ngIf="isExporting" class="me-1"></mat-spinner>
                    <i class="fa-solid fa-download me-1" *ngIf="!isExporting"></i>
                    Export CSV
                </button>
            </div>
        </div>
    </div>

    <!-- Filters Card -->
    <div class="filters-card mb-3" *ngIf="showCard">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-label">Data de la</label>
                        <input type="date" class="form-control" [(ngModel)]="dateFrom">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Data pana la</label>
                        <input type="date" class="form-control" [(ngModel)]="dateTo">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Status</label>
                        <select class="form-select" [(ngModel)]="statusFilter">
                            <option value="">Toate</option>
                            <option *ngFor="let status of statuses" [value]="status.value">{{ status.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Certificat</label>
                        <input type="text" class="form-control" [(ngModel)]="certificateFilter"
                            placeholder="Slug certificat">
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-2">
                        <label class="form-label">User ID</label>
                        <input type="text" class="form-control" [(ngModel)]="userIdFilter" placeholder="ID utilizator">
                    </div>
                    <div class="col-md-2">
                        <label class="form-label">Doc ID</label>
                        <input type="number" class="form-control" [(ngModel)]="documentIdFilter"
                            placeholder="ID document">
                    </div>
                    <div class="col-md-2">
                        <label class="form-label">Doc Generat ID</label>
                        <input type="number" class="form-control" [(ngModel)]="documentRegistraturaIdFilter"
                            placeholder="ID registratura">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Cautare</label>
                        <input type="text" class="form-control" [(ngModel)]="searchFilter"
                            placeholder="Fisier, user...">
                    </div>
                    <div class="col-md-3 d-flex align-items-end justify-content-end">
                        <button class="btn btn-secondary me-2" (click)="resetForm()">
                            <i class="fa-solid fa-times me-1"></i>
                            Reseteaza
                        </button>
                        <button class="btn btn-primary" (click)="applyFilters()">
                            <i class="fa-solid fa-search me-1"></i>
                            Aplica
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- DataTable -->
    <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
            class="table table-striped table-bordered w-100">
        </table>
    </div>

    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>